import React, { useEffect, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { Col, Row, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import Text from '../../components/inputTxt/Text';
import UploadIMG from "../../components/uploads/UploadIMG";
import { setTimeOutSync } from "../../utils/setTimeout";
import { getPromotionByID, createPromotion, updatePromotionByID } from "../../api/promotion_api.js";
import Calendarpicker from "../../components/calendars/Calendarpicker";
import { formatDate,formatDateDDMMYYYY } from "../../utils/formatDate.js";
import Modal from 'react-bootstrap/Modal';
import PreviewPromo from '../modal/PreviewPromo.js';
import moment from 'moment';
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
    alertNotFound
} from "../../components/alertValid/AlertValid.js"
import CustomCKEditor from '../../components/ckEditor/CustomCKEditor.js';
import CalendarToday from '../../components/calendars/CalendarToday.js';

function AddEditPrivilege() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [txtEnTitle, setTxtEnTitle] = useState('');
    const [txtThTitle, setTxtThTitle] = useState('');
    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [txtEnNote, setTxtEnNote] = useState('');
    const [txtThNote, setTxtThNote] = useState('');
    const [inputDiscount, setInputDiscount] = useState("");
    const [inputDateDiscount, setInputDateDiscount] = useState(null);
    const [inputDateEffective, setInputDateEffective] = useState(null);
    const [inputDateEnd, setInputDateEnd] = useState(null);
    const [inputDatePublish, setInputDatePublish] = useState(null);
    const [inputDatePublishFromApi, setInputDatePublishFromApi] = useState(null);
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [active, setActive] = useState(true);
    const [show, setShow] = useState(false);
    const [isChange, setIsChange] = useState(false)
    const [shouldActiveDisabled, setShouldActiveDisabled] = useState(false)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    function ChangesetValueDateDiscount(value) {
        setInputDateDiscount(moment(value).format('DD/MM/YYYY'));
    }
    function ChangesetValueDateEnd(value) {
        setInputDateEnd(moment(value).format('DD/MM/YYYY'));
    }
    function ChangesetValueDateEffective(value) {
        setIsChange(true)
        setInputDateEffective(moment(value).format('DD/MM/YYYY'));
    }
    function ChangesetValueDatePublish(value) {
        setIsChange(true)
        setInputDatePublish(moment(value).format('DD/MM/YYYY'));
    }

    const [inputForm, setInputForm] = useState({
        inp1: "",
        inp2: "",
        inp3: ""
    });
    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const handleDiscountChange = (e) => {
        setInputDiscount(e.target.value);
    };


    const [isPreviewDisabled, setIsPreviewDisabled] = useState(true);

    // useEffect(() => {
    //     const isIncomplete = !images1.length > 0 || !images2.length > 0 || !inputDiscount || !txtEnTitle || !txtEnDesc || !txtEnNote || !inputDateEffective || !inputDateEnd || !inputDateDiscount;
    //     setIsPreviewDisabled(isIncomplete);
    // }, [images1, images2, inputDiscount, txtEnTitle, txtEnDesc, txtEnNote, inputDateEffective, inputDateEnd, inputDateDiscount]);

    useEffect(() => {
        const isIncomplete = !images1.length > 0 || !images2.length > 0 || !inputDiscount || !txtEnTitle || !txtEnDesc || !txtEnNote || !inputDatePublish || !inputDateDiscount;
        setIsPreviewDisabled(isIncomplete);
    }, [images1, images2, inputDiscount, txtEnTitle, txtEnDesc, txtEnNote, inputDatePublish, inputDateDiscount]);

    const handleChangeInput50 = async (event,inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    const trimmedValue = inputValue.substring(0, 50); // Trim to 50 characters
                    //const lastSpaceIndex = trimmedValue.lastIndexOf(" ");
                    const finalValue = trimmedValue.substring(0); // Trim at last space
                    if (inpName=='enTitle') {                    
                        setTxtEnTitle(finalValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(finalValue);
                    }
                    else if (inpName == 'enNote') {
                        setTxtEnNote(finalValue)
                    }
                    else if (inpName == 'thNote') {
                        setTxtThNote(finalValue)
                    }
                }
                else {
                    if (inpName == 'enTitle') {                    
                        setTxtEnTitle(inputValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(inputValue);
                    }
                    else if (inpName == 'enNote') {
                        setTxtEnNote(inputValue)
                    }
                    else if (inpName == 'thNote') {
                        setTxtThNote(inputValue)
                    }
                }
        }
        else {
            if (inpName == 'enTitle') {                    
                setTxtEnTitle(inputValue);
            }
            else if (inpName == 'thTitle') {
                setTxtThTitle(inputValue);
            }
            else if (inpName == 'enNote') {
                setTxtEnNote(inputValue)
            }
            else if (inpName == 'thNote') {
                setTxtThNote(inputValue)
            }
        }
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const createPrivilegeData = async () => {
        let body = {
            type: 'priv',
            title_en: txtEnTitle,
            title_th: txtThTitle,
            description_en: txtEnDesc,
            description_th: txtThDesc,
            note_en: txtEnNote,
            note_th: txtThNote,
            discount: inputDiscount,
            discount_date: inputDateDiscount ? moment(inputDateDiscount, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
            // effective_date: inputDateEffective ?  moment(inputDateEffective, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
            // end_date: inputDateEnd ? moment(inputDateEnd, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
            publish_date: inputDatePublish ? moment(inputDatePublish, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
            cover_imgs: images2 ?? null,
            imgs: images1 ?? null,
            active: active == false ? 0 : 1,
        };
        if (
            !body.title_en ||
            !body.title_th ||
            !body.description_en ||
            !body.description_th ||
            !body.note_en ||
            !body.note_th ||
            !body.discount ||
            !body.discount_date |
            !body.publish_date ||
            // !body.effective_date ||
            // !body.end_date ||
            !body.cover_imgs.length > 0 ||
            !body.imgs.length > 0
            // !isDateRangeCorrect(body.effective_date, body.end_date)
        ) {
            await alertValidate();
        } else {
            const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createPromotion(body);
                        setLoading(false)
                            if (response.status == "success"||response.status == 200) {
                            const res = await alertSaved();
                              if (res.isConfirmed) {
                                navigateToBack("/infoPrivilege");
                              }
                          }
                      })();
                    }
        }
    };

    const updatePrivilegeData = async (id) => {
       
        let body = {
                type: 'priv',
                title_en: txtEnTitle,
                title_th: txtThTitle,
                description_en: txtEnDesc,
                description_th: txtThDesc,
                note_en: txtEnNote,
                note_th: txtThNote,
                discount: inputDiscount,
                discount_date: inputDateDiscount ? moment(inputDateDiscount, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
                // effective_date: inputDateEffective ? moment(inputDateEffective, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
                // end_date: inputDateEnd ? moment(inputDateEnd, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
                publish_date: inputDatePublish  ? moment(inputDatePublish, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
                cover_imgs: images2 ?? null,
                imgs: images1 ?? null,
                active: active == false ? 0 : 1,
            };
            if (
                !body.title_en ||
                !body.title_th ||
                !body.description_en ||
                !body.description_th ||
                !body.note_en ||
                !body.note_th ||
                !body.discount ||
                !body.discount_date ||
                // !body.effective_date ||
                // !body.end_date ||
                !body.publish_date ||
                !body.cover_imgs.length > 0 ||
                !body.imgs.length > 0
                // !isDateRangeCorrect(body.effective_date, body.end_date)
            ) {
                await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
                await setLoading(true);
                const response = await updatePromotionByID(id, body);
                setTimeOutSync(() => setLoading(false)).then(async () => {
                    if (response.data.status == "success") {
                        const res = await alertSaved();
                        if (res.isConfirmed) {
                        navigateToBack("/infoPrivilege");
                        }
                    }else{
                        const res = await alertNotFound();
                            if (res.isConfirmed) {
                                // window.location.href = '/backoffice/infoPrivilege';
                                navigateToBack("/infoPrivilege")
                            } else {
                                // window.location.href = '/backoffice/infoPrivilege'
                                navigateToBack("/infoPrivilege")
                            }
                    }
                }).finally(() => setLoading(false))
                }
        }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const getDataPrivilege = async (id) => {
        await setLoading(true);
        const respon = await getPromotionByID(id);
        if(!respon){
            const res = await alertNotFound();
                if (res.isConfirmed) {
                    // window.location.href = '/backoffice/infoPrivilege';
                    navigateToBack("/infoPrivilege")
                } else {
                    // window.location.href = '/backoffice/infoPrivilege'
                    navigateToBack("/infoPrivilege")
                }
        }
        setTimeout(async () => {
            await setLoading(false);
        }, 1000);
    
        let dataPreview = respon.data.data;
    
        setEditId(dataPreview._id)
        setTxtEnTitle(dataPreview.title_en)
        setTxtThTitle(dataPreview.title_th)
        setTxtEnDesc(dataPreview.description_en)
        setTxtThDesc(dataPreview.description_th)
        setTxtEnNote(dataPreview.note_en)
        setTxtThNote(dataPreview.note_th)
        setInputDiscount(dataPreview.discount)
        setInputDateDiscount(formatDate(dataPreview.discount_date))
        // setInputDateEffective(formatDate(dataPreview.effective_date))
        // setInputDateEnd(formatDate(dataPreview.end_date))
        setInputDatePublish(new Date(dataPreview.publish_date))
        setInputDatePublishFromApi(formatDateDDMMYYYY(dataPreview.publish_date))
        setActive(dataPreview.active == 1 ? true : false);

        const imgsCover = dataPreview.cover_imgs;
            if (imgsCover && Array.isArray(imgsCover)) {
                const images = await Promise.all(imgsCover.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi2(images);
            }

        const imgsGallery = dataPreview.imgs;
            if (imgsGallery && Array.isArray(imgsGallery)) {
                const images = await Promise.all(imgsGallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
    };

    const handleActiveBtn = async (idData) => {
        if (idData) {
            updatePrivilegeData(idData);
        } else {
            createPrivilegeData();
        }
    };
    
        const handleClickCancel = async () => {
            const res = await alertCancel();
                    if (res.isConfirmed) {
                        navigateToBack("/infoPrivilege");
                    }
                    else { }
        };

        // useEffect(() => {
        //     if (inputDatePublish) {
        //       const today = new Date()
        //       console.log(today,inputDatePublish)
        //       setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        //     }
        // }, [inputDatePublish]);
        const setDate = (inputname,date) => {            
            console.log('setDate',inputname,date)
        };
        const handleDateChange = (date) => {
            setInputDatePublish(date); // อัปเดตวันที่ที่เลือก
            const today = new Date()
            console.log(today,date)
            setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        };
        function isSameDate(date1, date2) {
            //console.log(date1,date2)
            return (
                date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate()
            );
        }

    useEffect(() => {
        let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                getDataPrivilege(id);
                setEditId(id);
            }
    }, [])

    // useEffect(() => {

    //     const parseEff = moment(inputDateEffective, 'DD/MM/YYYY').format('YYYY-MM-DD')
    //     const parseEnd = moment(inputDateEnd, 'DD/MM/YYYY').format('YYYY-MM-DD')

    //     if(!moment(moment().format('YYYY-MM-DD')).isBetween(parseEff, parseEnd, undefined, '[]')) {
    //      // current date/time is not between, disallow user to  can change active/inactive
    //          setShouldActiveDisabled(true)
    //          setActive(false)
    //     }else{
    //      //   allow
    //         //  setActive(true)
    //         setActive(!isChange ? active : true)
    //         setShouldActiveDisabled(false)
    //     }
    //  }, [inputDateEnd, inputDateEffective])


    return (
        <>
            <style>
                {`
                    .react-datepicker-wrapper {
                        width: 100%;
                    }
                    .upload {
                        display: flex;
                        flex-direction: column; /* Stack items vertically by default */
                        position: relative;
                    }
                    .thumbsContainer {
                        display: flex; /* Change to flex to align children horizontally */
                        flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                        width: 100%;
                        margin-top: 0;
                    }
                    .thumb, .boxthumb {
                        display: inline-flex;
                        border-radius: 0;
                        margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                        width: 100px; /* Adjust the width to fit your design */
                        height: 70px;
                        box-sizing: border-box;
                        position: relative;
                        margin-top: 1rem;
                    }
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                    @media only screen and (max-width: 767px) {
                        .thumb, .boxthumb {
                            margin-left: 0;
                            margin-right: 15px;
                        }
                        .remark-dt {
                            margin-top: -25px;
                        }
                    }
                `}
            </style>
            {isLoading ? <Loading /> : ""}
            <Header parentmenu={"PROMOTION & PRIVILEGE"} />
            <Menu
                parentmenu={"infoPromotionPrivilege"}
                activemenu={"infoPrivilege"}
            />
            <div className="content-wrapper">
                <div className="container-fluid pdb-page">
                    <div className="box-white">
                        <Row>
                            <Col xs={12}>
                                {editId ? (
                                <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                    <img src="assets/icons/ic-promotion.png" className="ic-user01 me-2" alt="" />
                                    EDIT PROMOTION & PRIVILEGE<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> PROMOTION
                                </font>
                                ) : (
                                <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                    <img src="assets/icons/ic-promotion.png" className="ic-user01 me-2" alt="" />
                                    ADD PROMOTION & PRIVILEGE<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> PRIVILEGE
                                </font>
                                )}
                            </Col>
                        </Row>
                        <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={12}>
                                {editId ? (
                                    <font className="font-size01 colorBlack01 fontBold">
                                        EDIT PRIVILEGE
                                    </font>
                                ) : (
                                    <font className="font-size01 colorBlack01 fontBold">
                                        ADD PRIVILEGE
                                    </font>
                                )}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Text
                                        value={txtEnTitle}
                                        onChange={(e) => handleChangeInput50(e,'enTitle')}
                                        placeholder="Title *"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Text
                                        value={txtThTitle}
                                        onChange={(e) => handleChangeInput50(e,'thTitle')}
                                        placeholder="ข้อเรื่อง *"
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnDesc}
                                        onChange={(newData) => {
                                            setTxtEnDesc(newData);
                                        }}
                                        placeholder="Description *"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThDesc}
                                        onChange={(newData) => {
                                            setTxtThDesc(newData);
                                        }}
                                        placeholder="คำอธิบาย *"
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <Text
                                        value={txtEnNote}
                                        onChange={(e) => handleChangeInput50(e,'enNote')}
                                        placeholder="Note"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Text
                                        value={txtThNote}
                                        onChange={(e) => handleChangeInput50(e,'thNote')}
                                        placeholder="หมายเหตุ"
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3 d-flex align-items-center">
                                <Col xs={6} className="d-flex align-items-center">
                                    <Row className="d-flex align-items-center w-100">
                                        <Col xs={3} className='pe-0'>
                                            <label className="fontLight font-size01 colorBlack01">
                                            Discount <span className=' colorRed'>*</span>
                                            </label>
                                        </Col>
                                        <Col xs={9} className='pe-0'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="discount"
                                                placeholder="20 %"
                                                value={inputDiscount}
                                                onChange={handleDiscountChange}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6} className="d-flex align-items-center">
                                    <Row className="d-flex align-items-center w-100">
                                        <Col xs={3} className='pe-0'>
                                            <label className="fontLight font-size01 colorBlack01">
                                            Discount Date <span className=' colorRed'>*</span>
                                            </label>
                                        </Col>
                                        <Col xs={9} className='pe-0'>
                                            <Calendarpicker
                                                dataDate={inputDateDiscount??null}
                                                setDatePicker={setinput}
                                                inputname={"inp1"}
                                                ChangesetValueDate={ChangesetValueDateDiscount}
                                                inputDate={inputDateDiscount}
                                                minDate={new Date()}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="mt-3 d-flex align-items-center">
                                <Col xs={6} className="d-flex align-items-center">
                                    <Row className="d-flex align-items-center w-100">
                                        <Col xs={3} className='pe-0'>
                                            <label className="fontLight font-size01 colorBlack01">
                                            Publish Date <span className=' colorRed'>*</span>
                                            </label>
                                        </Col>
                                        <Col xs={9} className='pe-0'>
                                            <CalendarToday
                                                dataDate={inputDatePublishFromApi || null}
                                                setDatePicker={setDate} // Pass date change handler
                                                inputname={"inp2"}
                                                ChangesetValueDate={handleDateChange}
                                                inputDate={inputDatePublish}
                                                minDate={new Date()} // Ensure past dates are disabled
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                {/* <Col xs={6} className="d-flex align-items-center">
                                    <Row className="d-flex align-items-center w-100">
                                        <Col xs={3} className='pe-0'>
                                            <label className="fontLight font-size01 colorBlack01">
                                            End Date <span className=' colorRed'>*</span>
                                            </label>
                                        </Col>
                                        <Col xs={9} className='pe-0'>
                                            <Calendarpicker
                                                dataDate={inputDateEnd??null}
                                                setDatePicker={setinput}
                                                inputname={"inp3"}
                                                ChangesetValueDate={ChangesetValueDateEnd}
                                                inputDate={inputDateEnd}
                                                minDate={!isChange ? new Date() :  getMinDateFromStart(inputDateEffective)}
                                            />
                                        </Col>
                                    </Row>
                                </Col> */}
                            </Row>
                        </div>
                    </div>
                    <div className="box-white mt-4">
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Cover Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={7}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages2}
                                    images={imagesFromApi2}
                                    txtDetail={"jpg. / 960x460 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg2}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="box-white mt-4">
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="box-white mt-4">
                        <div className='mx-3'>
                            <Row className='ms-1 mt-4'>
                                <Col xs={12} className="p-0">
                                    <label className="fontLight font-size03 colorBlack01">
                                    Status
                                    </label>
                                </Col>
                            </Row>
                            <Form className="ml-1">
                                {["radio"].map((type) => (
                                    <div key={`inline3-${type}`} className="mt-2 mb-3">
                                    <Form.Check
                                        className="fontLight font-size03 colorBlack01 checked radio-item1"
                                        inline
                                        label="Active"
                                        name="group3"
                                        type={type}
                                        id={`inline3-${type}-1`}
                                        checked={active}
                                        onChange={(e) => setActive(true)}
                                    />
                                    <Form.Check
                                        className="fontLight font-size03 colorBlack01 radio-item1"
                                        inline
                                        label="Inactive"
                                        name="group3"
                                        type={type}
                                        id={`inline3-${type}-2`}
                                        checked={!active}
                                        onChange={(e) => setActive(false)}
                                    />
                                    </div>
                                ))}
                            </Form>
                        </div>
                    </div>
                    <Row className="ms-5 mt-4">
                        <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                            <button
                                className="btn-cancle01"
                                onClick={() => handleClickCancel()}
                            >
                                    CANCEL
                            </button>
                        </Col>
                        <Col xs={1} className="p-0 d-flex justify-content-center me-4">
                            <button
                                className="btn-preview"
                                disabled={isPreviewDisabled}
                                onClick={handleShow}
                            >
                                PREVIEW
                            </button>
                        </Col>
                        <Col xs={1} className="p-0 d-flex justify-content-end">
                            <button
                                className="btn-save01"
                                onClick={(e) => {
                                    handleActiveBtn(editId);
                                }}
                            >
                                SAVE
                            </button>
                        </Col>
                    </Row>
                    <Modal size="xl" show={show} onHide={handleClose}>
                        <Modal.Body className="p-4">
                            <PreviewPromo 
                                type="priv" 
                                cover={images1} 
                                discount={inputDiscount}
                                title={txtEnTitle}
                                desc={txtEnDesc}
                                note={txtEnNote}
                                // dateEff={inputDateEffective}
                                // dateEnd={inputDateEnd}
                                datePublish={inputDatePublish}
                                dateDis={inputDateDiscount}
                                save={()=>handleActiveBtn(editId)} 
                                close={()=>handleClose()} 
                            />
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
            <Footer/>
        </>
      )
    }

export default AddEditPrivilege;